import React from "react"

interface IImageActionButtonProps {
    label: string
    icon: React.ReactNode
    onClick?: () => void
    disabled?: boolean
    error?: boolean
}

export const ImageActionButton = (props: IImageActionButtonProps) => {
    const disabled = !!props.disabled
    const borderClass = props.error ? 'border-2 border-red-500' : ''
    const classes = `mt-3 rounded-lg bg-mediaBackground px-3 py-3 text-base w-fit flex flex-row items-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${borderClass}`
    const handleClick = () => {
        if (disabled) return
        props.onClick?.()
    }
    return (
        <div
          role="button"
          aria-disabled={disabled}
          onClick={handleClick}
          className={classes}
        >
          {props.icon}
          <div className={'text-base ml-3'}>{props.label}</div>
        </div>
    )
}